// extracted by mini-css-extract-plugin
module.exports = {"PromoContainer":"styles_PromoContainer__1OfMe","Link":"styles_Link__3kBwC"};